var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"someRunners"},[_c('v-card',[_c('h2',[_vm._v("Принудительный запуск")]),_c('v-btn',{staticClass:"mb-2",on:{"click":_vm.SendStatistic}},[_vm._v(" Отправить статистику ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }